<!-- MultiStep Form -->
<div class="container-fluid" id="grad1">
    <div class="row justify-content-center mt-0">
        <div class="col-11 col-sm-9 col-md-7 col-lg-6 text-center p-0 mt-3 mb-2">
            <div class="card px-0 pt-4 pb-0 mt-3 mb-3">
                <h2><strong>Sign Up Your User Account</strong></h2>
                <div class="row">
                    <div class="col-md-12 mx-0">
                        <form id="msform" [formGroup]="rgForm" (ngSubmit)="onSubmit()">
                            <!-- progressbar -->
                            <ul id="progressbar">
                                <li [ngClass]="{ active: count == 1 }" id="account">
                                    <strong>Account</strong>
                                </li>
                                <li id="personal" [ngClass]="{ active: count == 2 }">
                                    <strong>Qualification</strong>
                                </li>
                                <li id="payment" [ngClass]="{ active: count == 3 }">
                                    <strong>Clinic</strong>
                                </li>
                                <li id="confirm" [ngClass]="{ active: count == 4 }">
                                    <strong>Finish</strong>
                                </li>
                            </ul>
                            <!-- fieldsets -->
                            <fieldset *ngIf="count == 1">
                                <div class="form-card">
                                    <h2 class="fs-title">Account Information</h2>
                                    <input type="text" formControlName="name" placeholder="FullName" />
                                    <div *ngIf="f.name.touched && f.name.invalid" class="alert alert-successs">Name is required</div>

                                    <input type="email" formControlName="email" placeholder="Email Id" />
                                    <input type="password" formControlName="password" placeholder="Password" />
                                    <input maxlength="10" formControlName="phoneNo" placeholder="PhoneNo" />
                                </div>
                                <p id="note" style="color: red;"><strong>NOTE:Please fill all the details</strong></p>

                                <input type="button" name="next" [disabled]="
                    !rgForm.get('name').valid ||
                    !rgForm.get('email').valid ||
                    !rgForm.get('password').valid ||
                    !rgForm.get('phoneNo').valid 
                  " class="next action-button" value="Next Step" (click)="onPageNext()" />
                            </fieldset>
                            <fieldset *ngIf="count == 2">
                                <div class="form-card">
                                    <h2 class="fs-title">Personal Information</h2>
                                    <select formControlName="doctorType">
                    <option selected [disabled]="isDocType" value="null" >DoctorType</option
                    >
                    <option
                      *ngFor="let singleElem of doctorTypeAray"
                      [value]="singleElem._id"
                    >
                      {{ singleElem.name }}
                    </option>
                  </select>

                                    <input type="number" name="lname" placeholder="Experience in year" formControlName="experience" />

                                    <div style="display: inline-block;" style="width: 100%;">
                                        <select style="display: inline-block;
                                                    width: 25%;
                                                    margin: right 5px;" 
                        (change)="onChangeCountry($event.target.value)">
                      <option
                        selected
                        [disabled]="isSelectDefaultOption"
                        value="null"
                        >Country</option
                      >
                      <option *ngFor="let con of countryArray">{{
                        con.country
                      }}</option>
                    </select>
                                        <select formControlName="memberCouncil" style="display: inline-block; width: 75%;" [disabled]="isCbDisabled">
                      <option disabled selected value="null"
                        >Member Council Name</option
                      >
                      <option *ngFor="let sinCon of CouncilArray">{{
                        sinCon
                      }}</option>
                    </select>
                                    </div>

                                    <input type="text" placeholder="Medical Council Id" formControlName="memberCouncilId" />
                                    <div class="input-styleclass">
                                        <p-multiSelect [options]="degrees" formControlName="degree" autoWidth="false" [style]="{ width: '100%' }" [defaultLabel]="'Please Select Your Degree'"></p-multiSelect>
                                    </div>
                                </div>
                                <p id="note" style="color: red;"><strong>NOTE:Please fill all the details</strong></p>

                                <input type="button" name="previous" class="previous action-button-previous" (click)="onPreviousPage()" value="Previous" />
                                <input type="button" name="next" class="next action-button" [disabled]="
                    !rgForm.get('doctorType').valid ||
                    !rgForm.get('experience').valid ||
                    !rgForm.get('memberCouncilId').valid ||
                    !rgForm.get('degree').valid
                  " value="Next Step" butto (click)="onPageNext()" />
                            </fieldset>
                            <fieldset *ngIf="count == 3">
                                <div class="form-card">
                                    <h2 class="fs-title">Address</h2>
                                    <input type="text" placeholder="Clinic name" formControlName="clinic" />
                                    <input type="text" placeholder="line1" formControlName="line1" />
                                    <input type="text" placeholder="city" formControlName="city" />

                                    <p><b>state</b></p>
                                    <select id="state" formControlName="state">
                    <option value="AP"> Andhra Pradesh</option>
                    <option value="AR">Arunachal Pradesh</option>
                    <option value="AS">Assam</option>
                    <option value="BR">Bihar</option>
                    <option value="CG">Chhattisgarh</option>
                    <option value="GA">Goa</option>
                    <option value="GJ">Gujrat</option>
                    <option value="HR">Haryana</option>
                    <option value="HP">Himachal Pradesh</option>
                    <option value="JH">Jharkand</option>
                    <option value="KA">Karnataka</option>
                    <option value="KL">Kerla</option>
                    <option value="MP">Madhya Pradesh</option>
                    <option value="MH">Maharashtra</option>
                    <option value="MN">Manipur</option>
                    <option value="ML">Meghalaya</option>
                    <option value="MZ">Mizoram</option>
                    <option value="NL">Nagaland</option>
                    <option value="OD">Odisha</option>
                    <option value="PB">Punjab</option>
                    <option value="RJ">Rajasthan</option>
                    <option value="SK">Sikkim</option>
                    <option value="TN">Tamil Nadu</option>
                    <option value="TS">Telangana </option>
                    <option value="TR"> Tripura</option>
                    <option value="UP">Uttar Pradesh</option>
                    <option value="UK"> Uttarakhand </option>
                    <option value="WB">West Bengal</option>
                  </select>
                                    <input type="number" placeholder="pincode" formControlName="pincode" />

                                    <input type="number" placeholder="Daily Patientlimit" formControlName="patientLimit" />
                                    <input type="text" formControlName="consFee" placeholder="First Visit ConsultationFee" />

                                    <div class="input-styleclass">
                                        <p-multiSelect [options]="clinicDays" formControlName="clinicDays" autoWidth="false" [style]="{ width: '100%' }" [defaultLabel]="'Please Select Your Working Days'"></p-multiSelect>
                                    </div>
                                </div>
                                <p id="note" style="color: red;"><strong>NOTE:Please fill all the details</strong></p>

                                <input type="button" name="previous" (click)="onPreviousPage()" class="previous action-button-previous" value="Previous" />
                                <input type="submit" [disabled]="
                    !rgForm.get('clinic').valid ||
                    !rgForm.get('line1').valid ||
                    !rgForm.get('city').valid ||
                    !rgForm.get('state').valid ||
                    !rgForm.get('pincode').valid ||
                    !rgForm.get('patientLimit').valid ||
                    !rgForm.get('consFee').valid ||
                    !rgForm.get('clinicDays').valid
                  " name="make_payment" class="next action-button" [disabled]="!rgForm.valid" value="Confirm" />
                            </fieldset>
                            <fieldset *ngIf="count == 4">
                                <div class="form-card">
                                    <h2 class="fs-title text-center">Success !</h2>
                                    <br /><br />
                                    <div class="row justify-content-center">
                                        <div class="col-3">
                                            <img src="https://img.icons8.com/color/96/000000/ok--v2.png" class="fit-image" />
                                        </div>
                                    </div>
                                    <br /><br />
                                    <div class="row justify-content-center">
                                        <div class="col-7 text-center">
                                            <h5>You Have Successfully Signed Up</h5>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>